import { render, staticRenderFns } from "./DashboardNewMember.vue?vue&type=template&id=624a9c20&scoped=true"
import script from "./DashboardNewMember.vue?vue&type=script&setup=true&lang=ts"
export * from "./DashboardNewMember.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./DashboardNewMember.vue?vue&type=style&index=0&id=624a9c20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624a9c20",
  null
  
)

export default component.exports